module.exports = __webpack_public_path__ + "static/media/DankMono-Italic.d17a9033.woff2";